import { Box, useMediaQuery } from '@mui/material';
import { ReactComponent as CloseIcon } from '../../../../assets/images/close.svg';
import { FormItemTypes } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { DynamicFormBuilderContainer } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
var PSGFilter = function (_ref) {
    var data = _ref.data, onClose = _ref.onClose;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: isMobile ? '16px 0px' : 0,
            columnSize: 12,
            mt: isMobile ? 0 : 6,
            spacing: 0,
            justifyContent: 'space-between',
            alignItems: 'center',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Filter',
                    columnSize: 0,
                    fontSize: 'xl',
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "currentColor",
                        height: '20px',
                        width: '20px'
                    }),
                    columnSize: 0,
                    color: 'secondary',
                    onClick: function () {
                        onClose();
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            label: '',
            value: null,
            spacing: 0,
            columnSize: 12,
            gap: 2,
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: '',
                    label: '',
                    placeholder: 'Selected saved filter',
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Defect combination',
                    label: 'Defect combination',
                    displayExpr: 'DisplayName',
                    valueExpr: 'id',
                    columnSize: 12
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'Date range',
                    label: 'Date range',
                    options: [],
                    columnSize: 12
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    alignItems: 'end',
                    elements: [{
                            type: FormItemTypes.DatePicker,
                            name: 'StartDate',
                            label: 'Date',
                            value: null,
                            columnSize: 6,
                            placeholder: 'From'
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: 'EndDate',
                            label: '',
                            value: null,
                            columnSize: 6,
                            placeholder: 'To'
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            width: {
                xs: '350px'
            },
            justifyContent: 'space-between',
            position: 'fixed',
            bottom: 0,
            right: 0,
            spacing: 0,
            borderTop: '1px solid',
            borderColor: 'secondary.200',
            p: '16px 24px 24px 24px!important',
            columnGap: 2,
            bgcolor: 'white',
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'text',
                    children: 'Save filter',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'outlined',
                    children: 'Reset filters',
                    color: 'secondary',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'contained',
                    children: 'Apply',
                    columnSize: 0
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        padding: 3
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        formData: formData
    })));
};
export default PSGFilter;
